import { filter, map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../utils/network/generated/protoTypes";
import { TypeActionPlayerInfo } from "../info/player/actionPlayerInfo";
import { actionLimitedActionInfoReceived, TypeActionLimitedActionInfo, } from "./actionLimitedActionInfo";
export var epicLimitedActionInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionPlayerInfo.Received ||
            action.type === TypeActionLimitedActionInfo.Update;
    }), switchMap(function () {
        var state = state$.value;
        return deps.netSend({
            id: CommandCode.LimitedActionInfo,
            props: {
                playerId: state.playerInfo.playerId,
            },
        });
    }), retry(), map(function (res) {
        return actionLimitedActionInfoReceived(res.limitedAction);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/limited-action-info/epicLimitedActionInfo.ts
// module id = 1984
// module chunks = 3